import { atom } from "recoil";

export const PositionState = atom({
    key: 'PositionState',
    default: null,
});